module.exports = __webpack_public_path__ + "img/hero-2.00c1ea47.png";